<template>
  <b-row>
    <b-col>
      <b-card
        no-body
        :class="{ open: visibleBody }"
      >
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="cursor:pointer; padding: 1rem;background-color: #0080C9; color: white; font:45px; padding:15px;"
        >
          <span class="lead collapse-title">
            <strong>Información de la Cita</strong>
          </span>
          <i
            :class="
              visibleBody
                ? 'fas fa-chevron-up'
                : 'fas fa-chevron-down'
            "
          />
        </b-card-header>
        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">

            <b-form-group>
              <strong>
                <i
                  class="fas fa-id-card"
                  style="margin-right: 2px"
                />
                Cedula:
              </strong>
              <span id="v-name">
                {{ paciente.cedula }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-user-injured"
                  style="margin-right: 2px"
                />
                Paciente:
              </strong>
              <span id="v-name">
                {{ paciente.nombre }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-birthday-cake"
                  style="margin-right: 2px"
                />
                Edad:
              </strong
              >
              <span id="v-name">
                {{ paciente.edad }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-briefcase"
                  style="margin-right: 2px"
                />
                Ocupacion:
              </strong
              >
              <span id="v-name">
                {{ paciente.ocupacion }}
              </span>
            </b-form-group>

            <hr>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-user-md"
                  style="margin-right: 2px"
                />
                Doctor:
              </strong>
              <span id="v-name">
                {{ doctor.nombre }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-stethoscope"
                  style="margin-right: 2px"
                />
                Especialidad:
              </strong>
              <span id="v-name">
                {{ doctor.especialidad }}
              </span>
            </b-form-group>

            <hr>

            <b-form-group>
              <strong>
                <i class="fa-solid fa-shield-heart"/>
                Cobertura:
              </strong>
              
              <span id="v-name">{{ cita.cobertura.descripcion }}</span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-calendar-alt"
                  style="margin-right: 2px"
                />
                Fecha de la cita:
              </strong>
              <span id="v-name">
                {{ cita.fecha }}
              </span>
            </b-form-group>

            <b-form-group>
              <strong>
                <i
                  class="fas fa-clock"
                  style="margin-right: 2px"
                />
                Hora de la cita:
              </strong>
              
              <span id="v-name">{{ cita.hora }}</span>
            </b-form-group>

            <b-alert v-if="derivacion.caducada" show variant="danger">
              Derivacion caducada.
              Fin de vigencia: {{ derivacion.fechaFin || 'No registrada' }}
            </b-alert>

            <b-form-group v-if="cita.derivacion !== '0' && derivacion.fechaInicio">
              <strong>Inicio vigencia derivacion:</strong>
              <span id="v-name">{{ derivacion.fechaInicio }}</span>
            </b-form-group>

            <b-form-group v-if="cita.derivacion !== '0' && derivacion.fechaFin">
              <strong>Fin vigencia derivacion:</strong>
              <span id="v-name">{{ derivacion.fechaFin }}</span>
            </b-form-group>
            <hr>
           
            <b-form-group v-if="cita.derivacion !== '0'" >
              <strong>
                <span> Ver documento de la derivación: </span>
                <a style="text-decoration: none;">
                  <i
                    class="fas fa-newspaper"
                    style="margin-left: 2px; color: black; transition: color 0.3s;"
                    @click="onViewFile()"
                  />
                </a>
              </strong>
            </b-form-group>

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />

  </b-row>
</template>

<script>
import { calculateAgeWithDateString } from '@/shared/helpers';
import { ModalViewFile } from '@/shared/components';
import { citasService } from '@/views/citas/services';

export default {
  name: "InformacionCita",

  props: {
    tokenCita: {
      type: String,
      default: '',
    }
  },


  components: {
    ModalViewFile
  },
  

  created() {
    this.loadDataCita();
  },

  data() {
    return {
      pdfSrc: "",
      visibleBody: true,

      fileToView: null,
      isModalFileVisible: false,

      items: [
        "Documento"
      ],

      fields: [
        { key:"ver", label:"Ver" }
      ],

      paciente:{
        nombre: "",
        cedula: "",
        edad: "",
        ocupacion: "",
      },

      doctor:{
        nombre: "",
        especialidad: "",
      },

      cita:{
        fecha: "",
        hora: "",
        cobertura: "",
      },

      derivacion:{
        codigo:"",
        urlDerivacion: null,
        fechaInicio: null,
        fechaFin: null,
        caducada: false,
      }
    };
  },

  

  methods: {

    onViewFile(urlF = this.derivacion?.urlDerivacion) { 

      if( !urlF ) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "No se encontro el documento"
        })
        return;
      }
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },


    onVisibleBody(value) {
      this.visibleBody = value;
    },


    async loadDataCita() {

      const responseCita = await citasService.getByToken(this.tokenCita);

      if( !responseCita ) return;

      const dataPaciente = responseCita.paciente.persona;


      const paciente = {
        nombre    : `${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
        cedula    : dataPaciente.identificacion,
        edad      : calculateAgeWithDateString(dataPaciente.fechaNacimiento),
        ocupacion : dataPaciente.ocupacion?.descripcion
      }

      const doctor = {
        nombre       : `${responseCita?.doctor.idPersona.primerApellido} ${responseCita?.doctor.idPersona.primerNombre}`,
        especialidad : responseCita?.doctor.especialidad.descripcion
      }

      const cita = {
        fecha     : responseCita?.fechaCita,
        hora      : responseCita?.horaCita,
        cobertura : responseCita?.cobSeleccionada,
        derivacion: responseCita?.derivacion
      }

      this.paciente = paciente;
      this.doctor   = doctor;
      this.cita     = cita;
      this.derivacion.urlDerivacion = responseCita?.urlDerivacion;
      this.derivacion.fechaInicio = responseCita?.fecderivacion || null;
      this.derivacion.fechaFin = responseCita?.fecfinderivacion || null;
      this.derivacion.caducada = !!responseCita?.derivacionCaducada;

    }
  },


  watch: {
    tokenCita() {
      this.loadDataCita();
    }
  }
}
</script>
